import { InfoCircleOutlined } from "@ant-design/icons";
import { Popover } from "antd";

import styles from "../ConditionalFormItems.module.scss";

const RELATIVE_DATE_FORMAT_URL =
    "https://support.regal.ai/hc/en-us/articles/53280426269595-How-to-Use-Relative-Dates-in-Journey-Conditional-Match-Nodes";

export function RealtiveDatePopover(): JSX.Element {
    return (
        <Popover
            title={<b>Examples</b>}
            content={
                <div className={styles.relativeDatePopover}>
                    <span>now-3h-14m-6d = 3 hours, 14 minutes, 6 days ago</span>
                    <span>now+1M+1w = 1 month, 1 week from now</span>
                    <span>now/d = 12am today</span>
                    <span>now/d-1d = 1 day before 12am today</span>

                    <span className={styles.popoverLink}>
                        See more examples{" "}
                        <a href={RELATIVE_DATE_FORMAT_URL} target="_">
                            here.
                        </a>
                    </span>
                </div>
            }
        >
            <InfoCircleOutlined className={styles.relativeDatePopOverIcon} />
        </Popover>
    );
}
